import React from "react";
import { Input } from "antd";

interface Inputvalue {
  value: string;
  name: string;
  required: boolean;
}

interface InputFields {
  firstname: Inputvalue;
  lastname: Inputvalue;
  phone: Inputvalue;
  email: Inputvalue;
  address: Inputvalue;
  city: Inputvalue;
  state: Inputvalue;
  zip: Inputvalue;
}

interface QuoteFormInputFieldsProps {
  inputFields: InputFields;
  setInputFields: (value: InputFields) => void;
}
const QuoteFormInputFields = (props: QuoteFormInputFieldsProps) => {
  const { inputFields, setInputFields } = props;

  const getKeyValue = (keyName: string) => {
    switch (keyName) {
      case "firstname":
        return "firstname";
      case "lastname":
        return "lastname";
      case "phone":
        return "phone";
      case "email":
        return "email";
      case "address":
        return "address";
      case "city":
        return "city";
      case "state":
        return "state";
      case "zip":
        return "zip";
      default:
        return "firstname";
    }
  };

  const changeHandler = (keyname: string, inputValue: string) => {
    const keyvalue = getKeyValue(keyname);
    setInputFields({
      ...inputFields,
      [keyvalue]: {
        ...inputFields[keyvalue],
        value: inputValue,
      },
    });
    return;
  };

  return (
    <div className="flex-col-stretch w-100-P m-top-10" style={{ alignItems: "flex-start" }}>
      {Object.keys(inputFields).map((keyName: string) => {
        const keyvalue = getKeyValue(keyName);
        return (
          <div key={keyvalue} className="flex-col-stretch p-2 rem-pad-width w-100-P" style={{ alignItems: "flex-start" }}>
            <span className="fw-500 text-color-blue">
              {inputFields[keyvalue].name}
              {inputFields[keyvalue].required ? <span className="text-color-red">*</span> : ""}
            </span>
            <Input placeholder={inputFields[keyvalue].name} value={inputFields[keyvalue].value} onChange={(e) => changeHandler(keyvalue, e.target.value)} />
          </div>
        );
      })}
    </div>
  );
};
export default QuoteFormInputFields;
